import { Colors } from "../styles/constant";
import activAssureDiamondIcon from "../assets/icons/ActivAssureDiamondIcon.svg";
import activAssureDiamondIconRed from "../assets/icons/ActivAssureDiamondIcon-red.svg";
import activAssureDiamondPlusIcon from "../assets/icons/ActivAssureDiamondPlusIcon.svg";
import activAssureDiamondPlusIconRed from "../assets/icons/ActivAssureDiamondPlusIcon-red.svg";
import activFitPlusIcon from "../assets/icons/ActivFitPlusIcon.svg";
import activFitPlusIconRed from "../assets/icons/ActivFitPlusIcon-red.svg";
import activFitPreferredIcon from "../assets/icons/ActivFitPreferredIcon.svg";
import activFitPreferredIconRed from "../assets/icons/ActivFitPreferredIcon-red.svg";
import activHealthPlatinumEnhancedIcon from "../assets/icons/ActivHealthPlatinumEnhancedIcon.svg";
import activHealthPlatinumEnhancedIconRed from "../assets/icons/ActivHealthPlatinumEnhancedIcon-red.svg";
import activHealthPlatinumEssentialIcon from "../assets/icons/ActivHealthPlatinumEssentialIcon.svg";
import activHealthPlatinumEssentialIconRed from "../assets/icons/ActivHealthPlatinumEssentialIcon-red.svg";
import activOneMaxIcon from "../assets/icons/activonemax-gray.svg";
import activOneMaxIconRed from "../assets/icons/ActivOneMaxIcon-red.svg";
import activOneNxtIcon from "../assets/icons/activonenxt-gray.svg";
import activOneNxtIconRed from "../assets/icons/ActivOneNxtIcon-red.svg";
import superTopUpPlanBIcon from "../assets/icons/SuperTopUpPlanBIcon.svg";
import superTopUpPlanBIconRed from "../assets/icons/SuperTopUpPlanBIcon-red.svg";
import topUpPlanGenericIcon from "../assets/icons/TopUpPlanGenericIcon.svg";
import topUpPlanGenericIconRed from "../assets/icons/TopUpPlanGenericIcon-red.svg";
import BasePlanGenericIcon from "../assets/icons/BasePlanGenericIcon.svg";
import BasePlanGenericIconRed from "../assets/icons/BasePlanGenericIcon-red.svg";
import { T_InsuredDetail } from "../features/Feature_HealthInsurance/HealthInsurance_Types";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { isEmpty } from "lodash";
import { E_ChannelOptions } from "../globalTypes/GlobalTypes";
import { T_CmsPageOfferMartData } from "../features/Features_Cms/CmsPageVariable.Types";
import {
  transactionTypes,
  transactionApiStatus,
  motorInsuranceProductTypes,
  motorInsurerNames,
  transactionStatus,
  platformMobile,
  platformSuperApp,
  platformWeb,
} from "./constants";
import giftBoxIcon from "../assets/icons/abcd-gold-gift-icon.svg";
import alertCircleIcon from "../assets/icons/abcd-alert-circle-icon.svg";
import checkCircleIcon from "../assets/icons/abcd-check-circle-icon.svg";
import carInsuranceIcon from "../assets/icons/abcd-car-insurance-icon.svg";
import bikeInsuranceIcon from "../assets/icons/abcd-bike-insurance-icon.svg";
import iciciLombardInsurerLogo from "../assets/icons/abcd-iciciLombard-insurance-logo.svg";
import ackoInsurerLogo from "../assets/icons/abcd-acko-insurance-logo.svg";
import digitInsurerLogo from "../assets/icons/abcd-digit-insurance-logo.svg";
import amberClockIcon from "../assets/icons/abcd-clock-time-seven-icon.svg";

// Extend Day.js with the necessary plugin
dayjs.extend(customParseFormat);

export const CurrencyFormat = (value: string = "") => {
  if (!value) return "";
  let tempValue = value.includes(".") ? parseFloat(value) : parseInt(value);
  if ([0, 0.0].includes(tempValue)) {
    return "";
  }
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: tempValue.toString().includes(".") ? 2 : 0,
  }).format(tempValue);
};

export const CurrencyFormatText = (value: number = 0, withSymbol = true) => {
  let formatedValue = new Intl.NumberFormat("en-IN").format(value);
  if (withSymbol) {
    return "₹" + formatedValue;
  }
  return formatedValue;
};

export const currencyConvertor = (amountInNumber: any) => {
  let lacs: any, crores: any, formattedAmount: any;
  if (amountInNumber && !isNaN(amountInNumber)) {
    if (amountInNumber >= 10000000) {
      crores = (amountInNumber / 10000000).toFixed(2);
      formattedAmount =
        "₹" + (crores % 1 === 0 ? crores.split(".")[0] : crores) + " Crores";
    } else if (amountInNumber >= 100000) {
      lacs = (amountInNumber / 100000).toFixed(1);
      formattedAmount =
        "₹" + (lacs % 1 === 0 ? lacs.split(".")[0] : lacs) + " Lacs";
    } else {
      formattedAmount = CurrencyFormat(amountInNumber.toString());
    }
  } else formattedAmount = amountInNumber;
  if (!formattedAmount) return "";
  return formattedAmount;
};

export const getPolicyStatus = (status: string | "") => {
  switch (status) {
    case "PREMIUM WAIVER OR PAYOR DEATH":
      return "Waiver";
    case "PAID-UP ANNUITY/EXTENDED TERM-ULIP":
    case "PAID-UP ANNUITY/EXTENDED TERM":
    case "RPU ULIP":
      return "Paid-Up";
    case "PREMIUM PAYING":
      return "In-Force";
    case "LAPSED":
      return "Lapsed";
    case "DISCONTINUED":
      return "Discontinued";
    case "TERMINATED":
      return "Terminated";
    case "SURRENDERED":
      return "Surrendered";
    case "WAIVER":
      return "Waiver";
    default:
      return "";
  }
};

export const getStatusColor = (status: string | "") => {
  switch (status) {
    case "PREMIUM PAYING":
    case "PREMIUM WAIVER OR PAYOR DEATH":
    case "WAIVER":
      return Colors.cadmiumGreen;
    case "LAPSED":
    case "DISCONTINUED":
    case "PAID-UP ANNUITY/EXTENDED TERM-ULIP":
    case "PAID-UP ANNUITY/EXTENDED TERM":
    case "RPU ULIP":
      return Colors.iconYellow;
    case "SURRENDERED":
    case "TERMINATED":
      return Colors.red;
    default:
      return "";
  }
};

export const getPolicyType = (type: string | "") => {
  switch (type) {
    case "ULIP":
      return "Unit Linked Insurance Plan";
    case "PAR":
    case "NON-PAR":
    case "NON PAR":
      return "Savings Plan";
    case "ANNUITY":
      return "Retirement Plan";
    case "HEALTH":
      return "Critical Illness Plan";
    case "TERM":
      return "Term Plan";
    default:
      return "";
  }
};

export const getHiPolicyStatus = (status: string = "") => {
  let tempStatus = status.toLowerCase();
  if (tempStatus === "if") {
    return "Active";
  } else if (tempStatus === "expired") {
    return "Expired";
  } else if (tempStatus === "lapsed") {
    return "Lapsed";
  }
};

export const getHlPolicyStatus = (status: string = "") => {
  if (!status) {
    return "";
  }
  let tempStatus = status.toLowerCase();
  if (status === null || status === undefined) {
    return "";
  }
  if (tempStatus.toLowerCase() === "active") {
    return "Active";
  } else if (tempStatus.toLowerCase() === "closed") {
    return "Closed";
  } else {
    return "";
  }
};

export const getHiPolicyNameIcon = (
  name: string = "",
  pageName: string = ""
) => {
  switch (name.toLowerCase()) {
    case "platinum - essential":
      return pageName === "dashboard"
        ? activHealthPlatinumEssentialIcon
        : activHealthPlatinumEssentialIconRed;
    case "platinum - enhanced":
      return pageName === "dashboard"
        ? activHealthPlatinumEnhancedIcon
        : activHealthPlatinumEnhancedIconRed;
    case "preferred":
      return pageName === "dashboard"
        ? activFitPreferredIcon
        : activFitPreferredIconRed;
    case "plus":
      return pageName === "dashboard" ? activFitPlusIcon : activFitPlusIconRed;
    case "diamond":
      return pageName === "dashboard"
        ? activAssureDiamondIcon
        : activAssureDiamondIconRed;
    case "diamond plus":
      return pageName === "dashboard"
        ? activAssureDiamondPlusIcon
        : activAssureDiamondPlusIconRed;
    case "max":
      return pageName === "dashboard" ? activOneMaxIcon : activOneMaxIconRed;
    case "nxt":
      return pageName === "dashboard" ? activOneNxtIcon : activOneNxtIconRed;
    case "base plan (generic":
      return pageName === "dashboard"
        ? BasePlanGenericIcon
        : BasePlanGenericIconRed;
    case "top up plan (generic":
    case "plan a":
      return pageName === "dashboard"
        ? topUpPlanGenericIcon
        : topUpPlanGenericIconRed;
    case "plan b":
      return pageName === "dashboard"
        ? superTopUpPlanBIcon
        : superTopUpPlanBIconRed;
    default:
      return undefined;
  }
};

export const getHiMembersInsured = (
  insuredDetails: T_InsuredDetail[],
  FamilyDefinition: string
) => {
  let policyType = FamilyDefinition?.toLowerCase();
  let displayString = "";
  if (["individual", "family floater"].includes(policyType)) {
    let isSelf =
      insuredDetails.filter((item) => item.vchRelation.toLowerCase() === "self")
        .length > 0;
    let isSpouse =
      insuredDetails.filter(
        (item) => item.vchRelation.toLowerCase() === "spouse"
      ).length > 0;
    let kidsCount = insuredDetails.filter(
      (item) => !["self", "spouse"].includes(item.vchRelation.toLowerCase())
    ).length;
    if (isSelf) displayString += "Self";
    if (isSpouse) {
      if (displayString) displayString += ", ";
      displayString += "Spouse";
    }
    if (kidsCount > 0) {
      if (displayString) displayString += ", ";
      displayString += kidsCount === 1 ? "1 kid" : `${kidsCount} kids`;
    }
  } else if (policyType === "multi-individual") {
    const memberCount = insuredDetails.length;
    return `${memberCount} members`;
  }
  return displayString;
};

export const getOrdinalDateSuffix = (day: any) => {
  if (day > 3 && day < 21) return "th"; // exception for 11th, 12th, 13th
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatDateWithOrdinal = (dateStr: any) => {
  const date = dayjs(dateStr, "DD/MM/YYYY hh:mm:ss A");
  const day = date.date();
  const month = date.format("MMMM");
  const year = date.format("YYYY");
  const suffix = getOrdinalDateSuffix(day);

  return `${month} ${day}${suffix}, ${year}`;
};
export const todayDate = dayjs().format("DD-MM-YYYY");

export const filterValidOfferMartData = (
  offerMartDetail: any,
  offerMartCardData: T_CmsPageOfferMartData[],
  csAppSlice: any
) => {
  const userDetails = csAppSlice?.userDetails;
  const today = new Date();
  const fields = ["offer", "productCategory", "segment"]; // Fields to reset
  // Loop through validity checks and reset related fields
  for (let i = 1; i <= 3; i++) {
    const validityKey = `validity${i}`;
    if (new Date(offerMartDetail?.[validityKey]) < today) {
      fields.forEach((field) => {
        offerMartDetail[`${field}${i}`] = null;
      });
    }
  }
  // Map segments from API1 to human-readable values
  const segmentMapping: Record<string, string> = {
    PA: "Pre-Approved",
    PQ: "Pre-Qualified",
    NBO: "Next Best Offer",
    PASA: "Pre-Approved Sum Assured",
    HP: "High Propensity",
  };
  // Extract filter conditions from API1 response
  const filterConditions = [
    {
      productName: offerMartDetail?.productCategory1,
      segment: segmentMapping[offerMartDetail?.segment1],
    },
    {
      productName: offerMartDetail?.productCategory2,
      segment: segmentMapping[offerMartDetail?.segment2],
    },
    {
      productName: offerMartDetail?.productCategory3,
      segment: segmentMapping[offerMartDetail?.segment3],
    },
  ];

  const channels = Array.from(
    new Set(
      userDetails?.customerAndLobDetails
        .map((item: any) => item?.CHANNEL?.toLowerCase())
        .filter(Boolean)
    )
  );

  let lobCodes = Array.from(
    new Set(
      userDetails?.customerAndLobDetails
        .map((item: any) => item.LOB_CODE)
        .filter(Boolean)
    )
  );
  if (isEmpty(lobCodes)) {
    lobCodes.push("NTB");
  }
  const isSuperApp = csAppSlice.channel === E_ChannelOptions.SUPER_APP; // true only when running on super app
  const isMobileApp = !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName); // true only for mobile App
  const isWeb = isSuperApp ? false : isMobileApp ? false : true; // true when runs on browser

  // Filter logic
  const finalOfferMartCard = offerMartCardData
    ?.filter((item: any) => {
      const productName = item?.attributes?.productName;
      const segment = item?.attributes?.segment;
      const cardChannels = item.attributes?.channel
        ?.split(",")
        .map((channel: string) => channel?.trim().toLowerCase());
      const requiredPlatforms =
        item.attributes.platform
          ?.toLowerCase()
          .split(",")
          .map((p: string) => p.trim()) || [];
      const lobIds = item?.attributes?.lobId
        ?.split(",")
        .map((id: string) => id.trim());

      // Check if productName and segment match any filter condition
      const matchesFilter = filterConditions.some(
        (condition) =>
          condition?.productName?.toLowerCase() ===
            productName?.toLowerCase() &&
          condition?.segment?.toLowerCase() === segment?.toLowerCase()
      );
      // Check if lobId includes any of the required values
      let isLobIdValid: boolean = true;
      lobCodes?.forEach((code) => {
        if (!isLobIdValid) {
          return;
        }
        if (!lobIds?.includes(code)) {
          isLobIdValid = false;
        }
      });
      // Check if channel includes any of the required values
      let matchedChannelData = channels?.filter((channel) =>
        cardChannels?.includes(channel)
      );
      const isChannelValid: any = isEmpty(matchedChannelData);

      const isPlatformValid =
        (requiredPlatforms.includes(platformWeb) && isWeb) ||
        (requiredPlatforms.includes(platformMobile) && isMobileApp) ||
        (requiredPlatforms.includes(platformSuperApp) && isSuperApp);

      return matchesFilter && isChannelValid && isPlatformValid && isLobIdValid;
    })
    ?.map((item: any) => {
      const productName = item?.attributes?.productName;
      // Add `roi` and `amount` based on productName
      const updatedItem = { ...item }; // Create a shallow copy to avoid direct modification
      if (productName === "Personal Loan") {
        updatedItem["roi"] = offerMartDetail?.plpaRoi;
        updatedItem["amount"] = offerMartDetail?.plpaOfferAmount;
        updatedItem["productName"] = productName;
      } else if (productName === "Business Loan") {
        updatedItem["roi"] = offerMartDetail?.blpaRoi;
        updatedItem["amount"] = offerMartDetail?.blpaOfferAmount;
        updatedItem["productName"] = productName;
      } else if (productName === "Home Loan") {
        updatedItem["amount"] = offerMartDetail?.hlPaOfferAmount;
        updatedItem["roi"] = offerMartDetail?.hlRoi;
        updatedItem["productName"] = productName;
      } else if (productName.toLowerCase() === "life insurance") {
        updatedItem["productName"] = productName.toLowerCase();
        updatedItem["sumAssured"] =
          offerMartDetail?.termLiPasaValues &&
          offerMartDetail?.termLiPasaValues !== "0"
            ? offerMartDetail?.termLiPasaValues
            : offerMartDetail?.nontermLiPasaValues;
      }
      return updatedItem;
    });
  return finalOfferMartCard;
};

//ABCD Holdings helper functions start
export const getRecentTransactionsIcon = (status?: string, type?: string) => {
  const statusValue = status?.toLowerCase();
  const isTransfer = type === transactionTypes.transfer;
  const isBuyRedeemSell =
    type === transactionTypes.buy ||
    type === transactionTypes.redeem ||
    type === transactionTypes.sell;

  switch (true) {
    // Case: Transfer completed or successful
    case isTransfer &&
      (statusValue === transactionApiStatus.successful ||
        statusValue === transactionApiStatus.transferred):
      return giftBoxIcon;

    // Case: Buy, Redeem, Sell successful, or Transfer reversed
    case (isBuyRedeemSell && statusValue === transactionApiStatus.successful) ||
      (isTransfer && statusValue === transactionApiStatus.reversed):
      return checkCircleIcon;

    // Case: Buy, Redeem, Sell or Transfer in progress
    case (isBuyRedeemSell && statusValue === transactionApiStatus.inProgress) ||
      (isTransfer && statusValue === transactionApiStatus.inProgress):
      return amberClockIcon;

    // Case: Buy, Redeem, Sell or Transfer failed
    case (isBuyRedeemSell && statusValue === transactionApiStatus.failure) ||
      (isTransfer && statusValue === transactionApiStatus.failure) ||
      statusValue === transactionApiStatus.failure:
      return alertCircleIcon;

    // Default case: return empty string
    default:
      return "";
  }
};

export const getMotorInsuranceProductIcon = (type?: string) => {
  if (type?.toLowerCase() === motorInsuranceProductTypes.car) {
    return carInsuranceIcon;
  } else {
    return bikeInsuranceIcon;
  }
};

export const getMotorInsurerProductLogo = (insurerName?: string) => {
  if (insurerName?.toLowerCase() === motorInsurerNames.iciciLombard) {
    return iciciLombardInsurerLogo;
  } else if (insurerName?.toLowerCase() === motorInsurerNames.acko) {
    return ackoInsurerLogo;
  } else {
    return digitInsurerLogo;
  }
};

export const dateDifferenceCalculator = (
  startDate: string,
  endDate: string
) => {
  const start = dayjs(startDate); // Parse start date string
  const end = dayjs(endDate); // Parse end date string

  // Calculate the difference in days
  const diffInDays = end.diff(start, "day");

  // Convert days to years
  const diffInYears = Math.ceil(diffInDays / 365);

  if (diffInYears > 1) {
    return `${diffInYears} years`;
  } else {
    return `${diffInYears} year`;
  }
};

export const getRecentTransactionsText = (status: string) => {
  switch (status.toLowerCase()) {
    case transactionApiStatus.successful:
    case transactionApiStatus.transferred:
      return transactionStatus.success;
    case transactionApiStatus.inProgress:
      return transactionStatus.inProgress;
    case transactionApiStatus.failed:
    case transactionApiStatus.failure:
      return transactionStatus.failed;
    case transactionApiStatus.reversed:
      return transactionStatus.reversed;
    default:
      return "";
  }
};

export const getRecentTransactionsTextColor = (status: string) => {
  switch (status.toLowerCase()) {
    case transactionApiStatus.successful:
    case transactionApiStatus.reversed:
    case transactionApiStatus.transferred:
      return Colors.cadmiumGreen;
    case transactionApiStatus.inProgress:
      return Colors.amber;
    case transactionApiStatus.failed:
    case transactionApiStatus.failure:
      return Colors.red;
    default:
      return "";
  }
};

export const formatAmount = (amount: string): string => {
  const number = parseFloat(amount);

  if (number % 1 === 0) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  }

  const formattedNumber = parseFloat(number.toFixed(2));
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(formattedNumber);
};

export const formatVehicleNumber = (value: string) => {
  const stateCode = value.substring(0, 2);
  const districtCode = value.substring(2, 4);
  const vehicleTypeCode = value.substring(4, 6);
  const vehicleNumberDigits = value.substring(6);
  return `${stateCode} ${districtCode} ${vehicleTypeCode} ${vehicleNumberDigits}`;
};

export const getPolicyTermInYears = (days: number) => {
  if (typeof days !== "number" || days <= 0) {
    return "Invalid policy term";
  }
  const years = Math.round(days / 365);
  return `${years} year${years > 1 ? "s" : ""}`;
};
//ABCD Holdings helper functions end
